import type { CurrentUserProfile, LoginResponse } from './domain/types';

export const AUTH_STORAGE_KEY = 'procure-flo-session';

function isCurrentUserProfile(value: unknown): value is CurrentUserProfile {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const o = value as Record<string, unknown>;
  return (
    typeof o.userId === 'string' &&
    typeof o.displayName === 'string' &&
    typeof o.role === 'string' &&
    typeof o.isActive === 'boolean' &&
    typeof o.allRegions === 'boolean' &&
    Array.isArray(o.assignedRegionCodes) &&
    Array.isArray(o.assignedRegions) &&
    o.entitlements !== null &&
    typeof o.entitlements === 'object'
  );
}

export function readStoredAuth(): LoginResponse | null {
  try {
    const raw = window.localStorage.getItem(AUTH_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const data = JSON.parse(raw) as LoginResponse;
    if (!data?.token || !data?.username || !data?.displayName || !data?.role) {
      return null;
    }
    if (data.profile !== undefined && !isCurrentUserProfile(data.profile)) {
      delete data.profile;
    }
    return data;
  } catch {
    return null;
  }
}

export function writeStoredAuth(session: LoginResponse): void {
  window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
}

export function clearStoredAuth(): void {
  window.localStorage.removeItem(AUTH_STORAGE_KEY);
}
